import { Injectable } from '@angular/core';
import { ClaimService } from '@lsq-frontend/common-ui';
import {
    GetConfigurationSummaryRequest,
    GetConfigurationSummaryResponse,
    GetConfigurationSummaryService
} from '@lsq-frontend/remote-services/all-java/financing-mk2-services/buyer-account/get-configuration-summary';
import { ReplaySubject } from 'rxjs';
import { DashboardClaim } from '@lsq-frontend/remote-services/enterprise/common';
import { UserService } from '@lsq-frontend/angular-shared/features/user-service';

@Injectable({ providedIn: 'root' })
export class SupplyChainDirectBuyerAccountSharedService {
    private _canRevokeInvoicesSubject = new ReplaySubject<boolean>(1);
    public canRevokeInvoices$ = this._canRevokeInvoicesSubject.asObservable();
    private _allowDirectFileUploadsSubject = new ReplaySubject<boolean>(1);
    public allowDirectFileUploads$ = this._allowDirectFileUploadsSubject.asObservable();
    private _manageAllPaymentsSubject = new ReplaySubject<boolean>(1);
    public manageAllPayments$ = this._manageAllPaymentsSubject.asObservable();
    private _isBuyerPaidEarlyPaymentFeePercentageShownSubject = new ReplaySubject<boolean>(1);
    public isBuyerPaidEarlyPaymentFeePercentageShown$ =
        this._isBuyerPaidEarlyPaymentFeePercentageShownSubject.asObservable();
    private _isBuyerPaidEarlyPaymentTransactionFeeShownSubject = new ReplaySubject<boolean>(1);
    public isBuyerPaidEarlyPaymentTransactionFeeShown$ =
        this._isBuyerPaidEarlyPaymentTransactionFeeShownSubject.asObservable();
    private _isPayLaterEnabledSubject = new ReplaySubject<boolean>(1);
    public isPayLaterEnabled$ = this._isPayLaterEnabledSubject.asObservable();

    constructor(
        private _claimService: ClaimService,
        private _getConfigurationSummary: GetConfigurationSummaryService,
        public userService: UserService
    ) {
        this._getConfigurationSummary.dataStream.subscribe(
            (config: GetConfigurationSummaryResponse) => {
                this._canRevokeInvoicesSubject.next(config.canRevokeInvoices);
                this._allowDirectFileUploadsSubject.next(config.allowDirectFileUploads);
                // For some reason the generator isn't matching the backend source code,
                // so i'm checking for both values as a temporary solution.
                this._manageAllPaymentsSubject.next(
                    config.manageAllPayments || (config as any).isManageAllPayments
                );
                this._isBuyerPaidEarlyPaymentFeePercentageShownSubject.next(
                    config.buyerPaidEarlyPaymentFeePercentageVisible ||
                        (config as any).isBuyerPaidEarlyPaymentFeePercentageVisible
                );

                this._isBuyerPaidEarlyPaymentTransactionFeeShownSubject.next(
                    config.buyerPaidEarlyPaymentTransactionFeeVisible ||
                        (config as any).isBuyerPaidEarlyPaymentTransactionFeeVisible
                );

                this._isPayLaterEnabledSubject.next(config.isPayLaterEnabled);
            }
        );

        // Make sure to fetch new values if you logout and log back in.
        this.userService.user$.subscribe((user) => {
            if (
                !!user &&
                (this._claimService.isOnSync(DashboardClaim.FinancingBuyerPortal) ||
                    this._claimService.isOnSync(DashboardClaim.FinancingAccountPortal))
            ) {
                this._getConfigurationSummary.execute(new GetConfigurationSummaryRequest());
            }
        });
    }
}
